export function getObjectDate(date){
  date = date.replace(".000000Z","").replace("T"," ")
  let aux = date.split(' ');
  let data = aux[0].split('-');
  let hora = aux[1].split(':');

  let retorno = new Date(data[0], data[1]-1, data[2], hora[0], hora[1], hora[2]);
  return new Date(retorno.setHours(retorno.getHours()-3));
};

export function getTime(_date, fromComment = false){

  const calc = (d1, d2)=>{
    let dif = d1 - d2;
    // calc segundos
    dif = dif / 1000;
    if(dif < 60) return 'há pouco tempo';
    // calc minutos
    dif = dif / 60;
    if(dif < 60) return `há ${parseInt(dif)} minuto`+(parseInt(dif)>1?'s':'');
    // calc horas
    dif = dif / 60;
    if(dif < 24) return `há ${parseInt(dif)} hora`+(parseInt(dif)>1?'s':'');
    // calc dias
    dif = dif / 24;
    if(dif < 7) return `há ${parseInt(dif)} dia`+(parseInt(dif)>1?'s':'');
    // calc semanas
    dif = dif / 7;
    if(dif < 4) return `há ${parseInt(dif)} semana`+(parseInt(dif)>1?'s':'');
    // calc meses
    dif = dif / 4;
    if(dif < 12) return `há ${parseInt(dif)} `+(parseInt(dif)>1?'meses':'mês');
    // calc anos
    dif = dif / 12;
    return `há ${parseInt(dif)} ano`+(parseInt(dif)>1?'s':'');
  };
  
  let date = fromComment ? new Date(_date) : getObjectDate(_date)
  let dateNow = new Date();
  return calc(dateNow.getTime(), date.getTime());
}